import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconDimensions from 'components/icons/IconDimensions';
import IconOpenClose from 'components/icons/IconOpenClose';
import { colorGrayLight2 } from 'styles/layout/colors';
import { BUILD_YOUR_OWN_SOFA_LINK } from 'commons/constants';
import PDPDesktopHeroThumbnail from '../PDPDesktopHeroThumbnail';
import IconFourSquare from '../../../../icons/iconFourSquare';
const DEFAULT_DIMENSION_SHOT_URLS = [];
const DEFAULT_PHOTOS = [];
const PDPDesktopConfigThumbnails = t0 => {
  const $ = _c(35);
  const {
    isMechanicalOpen: t1,
    toggleMechanicalOpen,
    dimensionsImage,
    shouldShowDimensionThumbnail: t2,
    dimensionShotUrls: t3,
    enableCrops,
    isConfigFlipped: t4,
    isCylindoConfigurationPhotos: t5,
    loading: t6,
    pdpIsModularBYOProduct: t7,
    photos: t8,
    selectedPhoto: t9,
    setSelectedPhoto,
    viewGalleryImageEvent
  } = t0;
  const isMechanicalOpen = t1 === undefined ? null : t1;
  const shouldShowDimensionThumbnail = t2 === undefined ? false : t2;
  const dimensionShotUrls = t3 === undefined ? DEFAULT_DIMENSION_SHOT_URLS : t3;
  const isConfigFlipped = t4 === undefined ? false : t4;
  const isCylindoConfigurationPhotos = t5 === undefined ? false : t5;
  const loading = t6 === undefined ? false : t6;
  const pdpIsModularBYOProduct = t7 === undefined ? false : t7;
  const photos = t8 === undefined ? DEFAULT_PHOTOS : t8;
  const selectedPhoto = t9 === undefined ? null : t9;
  if (loading) {
    let t10;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="flex">{[0, 1, 2, 3, 4].map(_temp)}</div>;
      $[0] = t10;
    } else {
      t10 = $[0];
    }
    return t10;
  }
  const showDimensionThumbnail = shouldShowDimensionThumbnail ?? (!!dimensionsImage || dimensionShotUrls.length > 0);
  const numOfPhotosToShow = showDimensionThumbnail ? 5 : 6;
  let t10;
  let t11;
  let t12;
  if ($[1] !== enableCrops || $[2] !== isConfigFlipped || $[3] !== isCylindoConfigurationPhotos || $[4] !== isMechanicalOpen || $[5] !== numOfPhotosToShow || $[6] !== pdpIsModularBYOProduct || $[7] !== photos || $[8] !== selectedPhoto || $[9] !== setSelectedPhoto || $[10] !== toggleMechanicalOpen || $[11] !== viewGalleryImageEvent) {
    const photosToShow = photos.slice(0, numOfPhotosToShow);
    t10 = "flex";
    if ($[15] !== isConfigFlipped || $[16] !== isMechanicalOpen || $[17] !== toggleMechanicalOpen) {
      t11 = isMechanicalOpen != null && <PDPDesktopHeroThumbnail ariaLabel={isMechanicalOpen ? "Close recliner" : "Open recliner"} title={isMechanicalOpen ? "Close recliner" : "Open recliner"} ariaPressed={isMechanicalOpen} onClick={toggleMechanicalOpen} isSelected={isMechanicalOpen} icon={<IconOpenClose width={30} height={30} color={colorGrayLight2} />} type="open-close" isConfigFlipped={isConfigFlipped} />;
      $[15] = isConfigFlipped;
      $[16] = isMechanicalOpen;
      $[17] = toggleMechanicalOpen;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    t12 = photosToShow.map((t13, index) => {
      const {
        id,
        src,
        cropData,
        type
      } = t13;
      return <PDPDesktopHeroThumbnail cropData={cropData} enableCrops={enableCrops} key={id} onClick={() => {
        setSelectedPhoto?.({
          type,
          id,
          index,
          src
        });
      }} onMouseEnter={() => {
        setSelectedPhoto?.({
          type,
          id,
          index,
          src
        });
        viewGalleryImageEvent({
          imageLocation: "Configuration Gallery",
          imageFilename: src?.split("/").pop() || "",
          position: index,
          totalImages: photos.length
        });
      }} onLoadFailure={() => {
        if (pdpIsModularBYOProduct && selectedPhoto === id) {
          let newType = "configuration";
          let newIndex = 0;
          if (index === 0) {
            if (photosToShow.length > 1) {
              newIndex = 1;
            } else {
              newType = "studio";
            }
          }
          setSelectedPhoto?.({
            type: newType,
            index: newIndex
          });
        }
      }} type="configuration" src={src} isSelected={pdpIsModularBYOProduct ? selectedPhoto === id : selectedPhoto === src} isConfigFlipped={isConfigFlipped} isCylindoPhoto={isCylindoConfigurationPhotos} />;
    });
    $[1] = enableCrops;
    $[2] = isConfigFlipped;
    $[3] = isCylindoConfigurationPhotos;
    $[4] = isMechanicalOpen;
    $[5] = numOfPhotosToShow;
    $[6] = pdpIsModularBYOProduct;
    $[7] = photos;
    $[8] = selectedPhoto;
    $[9] = setSelectedPhoto;
    $[10] = toggleMechanicalOpen;
    $[11] = viewGalleryImageEvent;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
  }
  let t13;
  if ($[19] !== pdpIsModularBYOProduct || $[20] !== selectedPhoto || $[21] !== setSelectedPhoto) {
    t13 = pdpIsModularBYOProduct ? <PDPDesktopHeroThumbnail enableCrops={false} key="build-your-own" onClick={() => {
      setSelectedPhoto?.({
        type: "buildyourown",
        index: 0
      });
    }} onMouseEnter={() => {
      setSelectedPhoto?.({
        type: "buildyourown",
        index: 0
      });
    }} type="buildyourown" icon={<IconFourSquare />} isSelected={selectedPhoto === BUILD_YOUR_OWN_SOFA_LINK} /> : null;
    $[19] = pdpIsModularBYOProduct;
    $[20] = selectedPhoto;
    $[21] = setSelectedPhoto;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== dimensionsImage || $[24] !== isConfigFlipped || $[25] !== selectedPhoto?.type || $[26] !== setSelectedPhoto || $[27] !== showDimensionThumbnail) {
    t14 = showDimensionThumbnail && <PDPDesktopHeroThumbnail key={dimensionsImage || "dimensions"} onClick={() => {
      setSelectedPhoto?.({
        type: "dimensional",
        index: 0
      });
    }} onMouseEnter={() => {
      setSelectedPhoto?.({
        type: "dimensional",
        index: 0
      });
    }} isSelected={selectedPhoto?.type === "dimensional"} icon={<IconDimensions width={24} height={24} color={colorGrayLight2} />} isConfigFlipped={isConfigFlipped} />;
    $[23] = dimensionsImage;
    $[24] = isConfigFlipped;
    $[25] = selectedPhoto?.type;
    $[26] = setSelectedPhoto;
    $[27] = showDimensionThumbnail;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t14) {
    t15 = <div className={t10}>{t11}{t12}{t13}{t14}</div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
};
PDPDesktopConfigThumbnails.propTypes = {
  isMechanicalOpen: PropTypes.bool,
  toggleMechanicalOpen: PropTypes.func,
  dimensionsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  shouldShowDimensionThumbnail: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  isConfigFlipped: PropTypes.bool,
  isCylindoConfigurationPhotos: PropTypes.bool,
  loading: PropTypes.bool,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  selectedPhoto: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setSelectedPhoto: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func
};
export default PDPDesktopConfigThumbnails;
function _temp(idx) {
  return <PDPDesktopHeroThumbnail key={idx} loading={true} />;
}